"use strict";
// Border-top-width property parser
// Handles parsing of CSS border-top-width property according to MDN specification
// https://developer.mozilla.org/en-US/docs/Web/CSS/border-top-width
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const shared_border_width_1 = require('./shared-border-width.cjs');
/**
 * Parse a CSS border-top-width property string
 * Accepts non-negative lengths and border width keywords (thin, medium, thick)
 *
 * @param value - The CSS border-top-width property value
 * @returns Parsed border top width value or null if invalid
 */
function parse(value) {
    return (0, shared_border_width_1.parseBorderWidthProperty)(value);
}
/**
 * Convert BorderTopWidthValue back to CSS string
 *
 * @param parsed - The parsed border top width value
 * @returns CSS string representation or null if invalid
 */
function toCSSValue(parsed) {
    return (0, shared_border_width_1.borderWidthToCSSValue)(parsed);
}
